import React, { useState } from 'react';
import chooseSupplierData from '../../../data/chooseSupplierData.json';

const ChooseSupplierScreen = ({ handleTabChange }) => {
  const [checkedItems, setCheckedItems] = useState({});

  const handleCheckboxChange = (event, index) => {
    event.stopPropagation();
    setCheckedItems({
      ...checkedItems,
      [index]: !checkedItems[index], // toggle the checked state
    });
  };

  const renderStars = (reviewCount) => {
    let stars = [];
    for (let i = 0; i < reviewCount; i++) {
      stars.push(<span key={i}>⭐</span>);
    }
    return stars;
  };

  return (
    <div>
      <div className="flex flex-col space-y-3 mt-3 overflow-x-auto">
        {chooseSupplierData &&
          chooseSupplierData['data'] &&
          chooseSupplierData['data'].map((data, index) => (
            <div
              className={`grid grid-cols-[50px_50px_200px_200px_200px_200px_200px] gap-4 max-w-fit border border-neutral-300 rounded-lg items-center p-2 ${
                checkedItems[index] ? 'bg-[#8B5CF6] text-white' : ''
              }`}
            >
              <div className="items-center">
                <input
                  type="checkbox"
                  className="ml-3 mt-2 h-5 w-5 text-indigo-600 rounded-full border-[2px] border-black"
                  checked={checkedItems[index] || false}
                  onChange={(event) => handleCheckboxChange(event, index)}
                />
              </div>
              <div className="grid grid-cols-subgrid col-span-6 hover:cursor-pointer">
                <img
                  alt="logo"
                  src="/Rectangle_107.png"
                  className="h-12 w-12"
                />
                <div className="flex flex-col items-center">
                  <p className="text-[14px]">Supplier Name</p>
                  <p className="text-[14px] font-bold">{data.supplier_name}</p>
                </div>
                <div className="flex flex-col items-center">
                  <p className="text-[14px]">Rating</p>
                  <p className="text-[14px] font-bold">
                    {renderStars(data.rating)}
                  </p>
                </div>
                <div className="flex flex-col items-center">
                  <p className="text-[14px]">Availibilty</p>
                  <p className="text-[14px] font-bold">{data.avaibility}</p>
                </div>
                <div className="flex flex-col items-center">
                  <p className="text-[14px]">Matching Score</p>
                  <p className="text-[14px] font-bold">{data.matching_score}</p>
                </div>
                <div className="flex flex-col items-center">
                  <p className="text-[14px]">Quote Value</p>
                  <p className="text-[14px] font-bold">{data.quote_value}</p>
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className="flex flex-row items-center justify-center space-x-4 mt-5">
        <button
          className="rounded-full px-8 py-2 text-[18px] text-left my-1 bg-blue-400 font-bold text-white"
          onClick={() => handleTabChange('bid_on_the_item')}
        >
          Next and Review
        </button>
      </div>
    </div>
  );
};

export default ChooseSupplierScreen;
